// @flow
/* eslint-disable ta-code-conventions/has-matching-storydoc */
/* eslint-disable ta-code-conventions/has-matching-test */

import React, { useCallback } from 'react';
import classNames from '@ta/common.classnames';
import { NavigableListItem } from '@ta/list.navigable-list';
import styles from './GeoPickerResult.css';

type Props = {|
  result: {
    value: number,
    name: string,
    details: {
      name: string,
      parent_name: string,
    },
  },
  active: boolean,
  onMouseMove: (SyntheticMouseEvent<HTMLElement>) => mixed,
  onSelect: (value: number, displayName: string, name: string) => mixed,
|};

/**
 * A selectable list item rendered in {@link ./GeoPicker}
 */
const GeoPickerResult = ({ result, active, onMouseMove, onSelect }: Props) => {
  const select = useCallback(() => {
    onSelect(result.value, result.details.name, result.name);
  }, [result, onSelect]);

  return (
    <NavigableListItem onSelection={select} onMouseMove={onMouseMove} active={active}>
      <div className={classNames(styles.result, { [styles.active]: active })}>
        <div className={styles.resultName}>{result.details.name}</div>
        <div className={styles.resultParentName}>{result.details.parent_name}</div>
      </div>
    </NavigableListItem>
  );
};

export default GeoPickerResult;
